
import TopPlayerComponent from './topplayers';
import BountiesPanelComponent from './bounties';

import './index.css';

const RightBarComponent = () => {
    return (
        <div id='rightbar-container'>
            <div className='rightbar-section'>
                <h3 id='topplayers-title'>Top Players</h3>
                <TopPlayerComponent />
            </div>

            <div className='rightbar-section'>
                <h3 id='bounties-title'>Bounties</h3>
                <BountiesPanelComponent />
            </div>

            <div className='rightbar-section'>
                <h3 id='gameinfo-title'>Game Information</h3>
            </div>
        </div>
    );
};

export default RightBarComponent;